export const MAX_PINNED_SIDEBAR_LINKS = 3;
const DASHBOARD_PATH = '/dashboard';

const getStorageKey = (userId) => (
  userId ? `event-manager-sidebar-pins:${userId}` : null
);

export const normalizePinnedSidebarLinks = (value, validPaths) => {
  if (!Array.isArray(value)) return [];

  const allowedPaths = new Set(validPaths);
  return [...new Set(value)]
    .filter((path) => (
      typeof path === 'string'
      && path !== DASHBOARD_PATH
      && allowedPaths.has(path)
    ))
    .slice(0, MAX_PINNED_SIDEBAR_LINKS);
};

export const readPinnedSidebarLinks = (userId, validPaths) => {
  const storageKey = getStorageKey(userId);
  if (!storageKey || typeof window === 'undefined') return [];

  try {
    return normalizePinnedSidebarLinks(
      JSON.parse(window.localStorage.getItem(storageKey) || '[]'),
      validPaths
    );
  } catch {
    return [];
  }
};

export const savePinnedSidebarLinks = (userId, pinnedPaths) => {
  const storageKey = getStorageKey(userId);
  if (!storageKey || typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(storageKey, JSON.stringify(pinnedPaths));
  } catch {
    // The navigation still works when browser storage is unavailable.
  }
};

export const orderSidebarLinks = (links, pinnedPaths) => {
  const linksByPath = new Map(links.map((link) => [link.to, link]));
  const pinnedLinks = pinnedPaths
    .filter((path) => path !== DASHBOARD_PATH)
    .map((path) => linksByPath.get(path))
    .filter(Boolean);
  const pinnedPathSet = new Set(pinnedLinks.map((link) => link.to));
  const dashboardLink = linksByPath.get(DASHBOARD_PATH);

  return [
    ...(dashboardLink ? [dashboardLink] : []),
    ...pinnedLinks,
    ...links.filter((link) => (
      link.to !== DASHBOARD_PATH && !pinnedPathSet.has(link.to)
    )),
  ];
};

